import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FilledInput from '@material-ui/core/FilledInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import Cookies from 'js-cookie';

import API_PATH from "../../constants/config.json";
import { setCookie } from '../../functions/Auth';
import { Container, CssBaseline } from '@material-ui/core';
import '../../scss/components/_user_details.scss';
import ErrorMessage from '../AppLayouts/ErrorMessage';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const AddUser = (props) => {

    const [firstName, setFirstName] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [organization, setOrganization] = React.useState('');

    const [errFirstName, setErrFirstName] = React.useState(null);
    const [errLastName, setErrLastName] = React.useState(null);
    const [errEmail, setErrEmail] = useState(null);
    const [validEmail, setValidEmail] = useState(false);
    const [errMsgNotEmpty, setErrMsgNotEmpty] = useState(null);

    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsgEmail, setErrMsgEmail] = React.useState(null);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [msgTitle, setMsgTitle] = useState(null);

    const [teamList, setTeamList] = useState([]);
    const [teamsArray, setTeamsArray] = React.useState([]);

    useEffect(() => {
      getTeamsAPI();
    }, [])
    
    const getTeamsAPI = (search = "", enable = false) => {
      try {
        axios({
          method: 'post',
          data: {
            pageNo: 1,
            entriesPerPage: 10,
            searchEnable: enable,
            searchValue: search
          },
          headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
          },
          url: API_URL + API_PATH.getTeamList,
        })
          .then(async function (response) {
            if (response.status && response.status == '200') {
              setTeamList(response.data.result.rows);
            } else {
              setTeamList([]);
            }
  
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.data.status == 403) {
                setTeamList([]);
              } else {
                setTeamList([]);
              }
            } else {
              setTeamList([]);
            }
          })
      } catch (error) {
        console.error(error);
      }
    }

    const handleToggleGroup = (e,group_id) => {
      let tmpgroups = [...teamsArray];
      if(e.target.checked) {
        tmpgroups.push(group_id);
      } else {
        tmpgroups = tmpgroups.filter( item => item !== group_id);
      }
      setTeamsArray(tmpgroups);
    }

    const handleChange = name => event => {
        let checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let val = event.target.value;
        if (name == 'first_name') {
          setFirstName(val);
          if(val === '') {
            setErrFirstName(true);
            setErrMsgNotEmpty('Cannot be empty');
          } else {
            setErrFirstName(false);
          }
        } else if (name == 'last_name') {
          setLastName(val);
          if(val === '') {
            setErrLastName(true);
            setErrMsgNotEmpty('Cannot be empty');
          } else {
            setErrLastName(false);
          }
        } else if (name == 'email') {
            let vEmail = checkEmail.test(val);
            setValidEmail(vEmail);
            setEmail(val);
            if(!vEmail){
                setErrEmail(true);
                setErrMsgEmail('Must be a valid email address');
            } else {
                setErrEmail(false);
            }

        } else if (name == 'organization') {
          setOrganization(val);
        }
    }

    const ShowErrPopUp = () => {
      setErrPopUp(false)
    };

    const createUser = (e) => {
        props.setNeedToReload(false);
        setErrMsg(null);
        e.preventDefault();
        let values = {
            first_name: firstName,
            last_name: lastName,
            createdby_email: Cookies.get('email'),
            organization: organization,
            email: email,
            teamId: teamsArray
        }
        
        try {
            axios({
              method: 'post',
              data:values
            ,
              headers: {
                'payload':Cookies.get('payload'),
                'agencyid':sessionStorage.getItem('agency_id')
              },
              url: API_URL + API_PATH.inviteNewUserAPIv2,
            })
              .then(function (response) {
                if (response.status && response.status == '200') {
                    setErrMsgType('custom_success');
                    setMsgTitle('Successfully created user');
                    setErrMsg('--');
                    setErrPopUp(true);
                    setFirstName('');
                    setLastName('');
                    setEmail('');
                    setOrganization('');
                    setValidEmail(false);
                    setTeamsArray([]);
                    props.setNeedToReload(true);
                } else {
                  setErrMsgType('error')
                  setErrMsg('Something went wrong.');
                  setErrPopUp(true);       
                }
              }).catch(function (error) {
                if (error.response) {
                  setErrMsgType('error')            
                  setErrMsg(error.response.data.message);            
                  setErrPopUp(true);
                } else {
                  setErrMsgType('error')
                  setErrMsg('Something went wrong.');
                  setErrPopUp(true);
                }
              })
        } catch (error) {
            console.error(error);
        }
    }

    const handleShowDisableUser = () => {
      setTeamsArray([]);
    }

    return (
        <React.Fragment>
            <CssBaseline />
            <div className="userdetails-main">
                <Container className="adduser-container" maxWidth="lg">
                    <div>
                        <div className="details-top">
                            <div>
                                <p>
                                    <label className="section-title">Add user</label>
                                </p>
                                <p className="section-description">Create a new user with the information below</p>
                            </div>
                            <img src={require('../../assets/icons/close.svg')} onClick={() => props.setShowAddUser(false)} />
                        </div>
                        <form className="root-form-details" noValidate autoComplete="off" onSubmit={e => createUser(e)}>
                            {errMsg ? <ErrorMessage message={errMsg} title={msgTitle} visible={ShowErrPopUp} show={errPopUp} msgType={errMsgType} /> : null}
                            <Grid container spacing={1} className="horizontal-divisor">
                                <Grid xs={6} item>
                                <Paper className="paper" >
                                    <p className="text-input-label">First Name</p>
                                    <FilledInput 
                                    id="first_name" 
                                    className={errFirstName ? "form-text-input-error" : "form-text-input"} 
                                    type="text" variant="outlined" required 
                                    value={firstName} 
                                    onChange={handleChange('first_name')}
                                    data-testid='first_name'  
                                    endAdornment={ errFirstName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                    />
                                    {errFirstName ? <p className="form-error-label">{errMsgNotEmpty}</p> : null}
                                </Paper>
                                </Grid>
                                <Grid xs={6} item>
                                <Paper className="paper" >
                                    <p className="text-input-label">Last Name</p>
                                    <FilledInput 
                                    id="last_name" 
                                    className={errLastName ? "form-text-input-error" : "form-text-input"} 
                                    type="text" variant="outlined" required 
                                    value={lastName} 
                                    onChange={handleChange('last_name')}
                                    data-testid='last_name'  
                                    endAdornment={ errLastName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                    />
                                    {errLastName ? <p className="form-error-label">{errMsgNotEmpty}</p> : null}
                                </Paper>
                                </Grid>
                                <Grid xs={6} item>
                                <Paper className="paper" >
                                    <p className="text-input-label">Email</p>
                                    <FilledInput 
                                    id="email" 
                                    className={errEmail ? "form-text-input-error" : "form-text-input"} 
                                    type="email" variant="outlined" 
                                    value={email}
                                    onChange={handleChange('email')}
                                    data-testid='email'  
                                    endAdornment={ errEmail && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                    />
                                    {errEmail ? <p className="form-error-label">{errMsgEmail}</p> : null}
                                </Paper>
                                </Grid>
                                <Grid xs={6} item style={{position: 'relative'}}>
                                    <Paper className="paper" >
                                        <p className="text-input-label">Organization</p>
                                        <FilledInput 
                                        id="organization" 
                                        className="form-text-input" 
                                        type="text" variant="outlined"
                                        value={organization}
                                        onChange={handleChange('organization')}
                                        data-testid='organization'  
                                        />
                                    </Paper>
                                    <label className="optional-lbl">Optional</label>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper className="paper" >
                                <p className="section-title">Assigned groups</p>
                                <p className="section-description">Permission levels associates with this account</p>
                                    {
                                        teamList.map((value, index) => {
                                            return (
                                                <FormControlLabel
                                                    control={<IOSSwitch checked={teamsArray.indexOf(value.teams_id) >= 0} onChange={(e) => handleToggleGroup(e,value.teams_id)} />}
                                                    label={value.team_name}
                                                />
                                            )
                                        })
                                    }
                                </Paper>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper className="buttons-cnt">
                                    <Button 
                                      className="disable-btn" 
                                      disabled={teamsArray.length > 0 ? false : true}
                                      onClick={() => handleShowDisableUser(true)}>
                                        Disable
                                    </Button>
                                    <div>
                                        <Button type="reset" variant="outlined" id="cancel_btn" className="cancel-btn" onClick={() => props.setShowAddUser(false)}>
                                            Cancel</Button>&nbsp;&nbsp;
                                        <Button 
                                          type="submit" 
                                          variant="outlined" 
                                          id="save_btn" 
                                          className="blue-btn font-14"
                                          disabled={firstName === '' || lastName === '' ? true : false || !validEmail || teamsArray.length === 0}
                                        >
                                            Create</Button>
                                    </div>
                                </Paper>
                            </Grid>
                        </form>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default AddUser;